export type LogContext = Record<string, unknown>;

export interface TrackerLogger {
  debug(operation: string, context?: LogContext): void;
  error(operation: string, context?: LogContext): void;
}

export const createLogger = (enabled: boolean, workspaceId?: string): TrackerLogger => {
  const base = { component: 'uplane-website-tracker', workspaceId };

  return {
    debug(operation, context = {}) {
      if (enabled) console.debug({ ...base, operation, ...context });
    },
    error(operation, context = {}) {
      if (enabled) console.error({ ...base, operation, ...context });
    }
  };
};
